import { useMemo } from "react";
import {
  usePreviewData,
  UsePreviewDataOptions,
} from "@/features/previews/shared/hooks/usePreviewData";
import { QRProps } from "@/contexts/QREditorContext/types";
import { PreviewSource } from "@/components/QRPreview/types";

export function useFeedbackData(props: QRProps<"feedback">, options?: UsePreviewDataOptions) {
  const { data, isInitPreview, hasContext } = usePreviewData(props, options);

  const isEditor = props?.source === PreviewSource.editor;

  const formattedData = useMemo(() => {
    if (!data) return null;

    return {
      logoUrl: data.logoUrl || "",
      themeColor: data.themeColor || { buttonColor: "#3F6F74", backgroundColor: "#A9D1D4" },
      title: data.title || "",
      subtitle: data.subtitle || "",
      categories: data.categories || [],
      rating_base: data.rating_base || 3,
      form: data.form || { name: false, phone: false, email: false },
    };
  }, [data]);

  return {
    data: formattedData,
    rawQrData: data,
    isInitPreview,
    isEditor,
    hasContext,
  };
}
